//タッチデバイスか否かで取得イベントを変える
// var getEvent = "ontouchstart" in window ? "orientationchange" : "resize";

//読み込み時
$(window).on("load", function () {
  // const spMax = 768;
  omitText();
});


//リサイズ
var timer = false;
var currentWidth = window.innerWidth;
$(window).on("resize", function () {
  if (timer !== false) {
    clearTimeout(timer);
  }
  timer = setTimeout(function () {
    //ブレイクポイントの設定
    // const spMax = 768;
    // ウインドウ横幅が変わっていないため処理をキャンセル。
    if (currentWidth == window.innerWidth) {
      return;
    }
    // ウインドウ横幅が変わったのでリサイズと見なす。
    // 横幅を更新
    currentWidth = window.innerWidth;

    omitText();

  }, 200);
});



// ====================
// メニュー開閉
// ====================
$(function () {

  var $nav = $('.navigation'),
    $btn = $('.navigation-btn'),
    $mask = $('.navigation-overlay'),
    open = 'is-opened',  // class
    close = 'is-closed'; // class
  // menu open close

  $btn.on('click', function () {

    // OPEN
    if (!$nav.hasClass(open)) {
      $nav.addClass(open);
      $btn.removeClass(close);
      htmlFix();

      // CLOSE
    } else {
      $nav.removeClass(open).scrollTop(0);
      $btn.addClass(close);
      htmlScroll();
    }
  });

  // MASK CLOSE
  $mask.on('click', function () {
    $nav.removeClass(open).animate({ scrollTop: 0 }, 1200, 'quart');
    $btn.addClass(close);
    htmlScroll();
  });

});

//ページ固定
function htmlFix() {
  var st = $(window).scrollTop() * -1;
  $("html").addClass("is-fixed");
  $("body").css("top", st);
}
//ページ固定解除
function htmlScroll() {
  var st = parseFloat($("body").css("top")) * -1;
  $("html").removeClass("is-fixed").scrollTop(st);
  $("body").removeAttr("style");
}


// ====================
// ○件以上のリストTOGGLE
// .js-list .js-list-item .js-list-btn .js-list-txt
// ====================
$(document).ready(function () {

  $(".js-list").each(function () {

    var listOver = $(this).find(".js-list-item:gt(11)"),
      listBtn = $(this).find(".js-list-btn");

    listOver.hide();

    // 6件以上無い場合はボタン非表示
    if (listOver.length == "0") {
      listBtn.hide();
    }

    // クリック
    listBtn.click(function (e) {
      //$(".js-list-btn").on("click", function(e) {
      e.stopPropagation();
      e.preventDefault();

      listOver.fadeIn(400);
      $(this).parent().fadeOut(200);

      //if( $(this).hasClass("is-opened")) {
      //$(this).removeClass("is-opened");
      //$(this).children(".js-list-txt").text("もっと見る");
      //} else {
      //$(this).addClass("is-opened");
      //$(this).children(".js-list-txt").text("閉じる");
      //}

    });

  });

});

// ====================
// ベーシックタブ
// ====================
$(function () {
  $('.js-tab-trigger').click(function (e) {
    e.preventDefault();

    //現在開いているタブを非活性に変更
    $('.js-tab-trigger').removeClass('is-active')
    $('.js-tab-panel').removeClass('is-active');

    var trigger = $(this),
      panel = $('#' + trigger.attr('href'));

    //タブコンテンツ開く
    trigger.addClass('is-active');
    panel.addClass('is-active');
  });
})

$(function () {
  $('.js-howto-tab-trigger').click(function (e) {
    e.preventDefault();

    //現在開いているタブを非活性に変更
    $('.js-howto-tab-trigger').removeClass('is-active')
    $('.js-howto-tab-panel').removeClass('is-active');

    var trigger = $(this),
      panel = $('#' + trigger.attr('href'));

    //タブコンテンツ開く
    trigger.addClass('is-active');
    panel.addClass('is-active');
  });
})

// ====================
// タブ セレクト
// js-tabSelect-trigger, js-tabSelect-panel
// ====================
$(function () {
  var trigger = $('.js-tabSelect-trigger'),
    panel = $('.js-tabSelect-panel');

  //初期表示
  if (!trigger.hasClass('is-shown')) {
    panel.hide();
  }

  // セレクトの中身が変化したら発動
  trigger.change(function () {

    panel.hide();

    tabSelect(this, panel);

  });
})

function tabSelect(t, p) {
  var t = $(t)

  p.each(function () {
    //選んだ選択肢がもつdata属性と同じdata属性の値をもつリストを表示
    if (t.children('option:selected').data('select-trigger') == $(this).data('select-panel')) {
      $(this).fadeIn();
    }
  })
}

// ====================
// トグル
// .js-toggle-trigger
// ====================
$(function () {
  var trigger = $(".js-toggle-trigger"),
    panel = $(".js-toggle-panel");

  //初期表示 パネル非表示
  panel.hide();

  //openクラス持ちは表示
  trigger.each(function () {
    if ($(this).hasClass("is-opened")) {
      $(this).next(panel).show().parents(".js-toggle").addClass("is-opened");
    }
  });

  trigger.on('click', function () {
    //トリガーがクリックされたら
    //開く対象がすでに開いている場合を除き、一旦全て閉じる処理
    // trigger.not($(this)).next(panel).slideUp();
    // trigger.not($(this)).removeClass('is-opened')

    //開閉、アイコン動作の処理
    $(this).next(panel).slideToggle();
    $(this).toggleClass('is-opened');
    $(this).parents(".js-toggle").toggleClass('is-opened');

    return false;
  })
})

// ====================
// チェックボックス インプット変化時チェック
// js-check-toggle, js-check-toggle-trigger, js-check-toggle-input
// ====================
$(function () {
  var parent = '.js-check-toggle',
    trigger = $('.js-check-toggle-trigger'),
    checkbox = '.js-check-toggle-checkbox';

  //トリガーの要素にフォーカスが当たった時、チェックボックスにチェックをいれる
  $(trigger).focus(function () {
    $(this).closest(parent).find(checkbox).prop('checked', true)
  })

  //トリガーの要素からフォーカスが外れた時、チェックボックスのチェックを外す
  $(trigger).blur(function () {
    if ($(this).val() == "") {
      $(this).closest(parent).find(checkbox).prop('checked', false)
    }
  });
})

// ====================
// もっと見る（フェードアウトしてるコンテンツ）
// ====================
$(function () {
  var moreBtn = $('.js-gradient-more-btn');

  $(moreBtn).click(function () {
    var moreContent = $(this).closest('.js-gradient-more-toggle').children('.js-gradient-more-content'),
      contentCurrentHeight = moreContent.data('original-height');

    //コンテンツによる表示速度の制御
    if (contentCurrentHeight == '132px') {
      var speed = 70,
        delay = 200;
    } else if (contentCurrentHeight == '62px') {
      var speed = 500,
        delay = 0;
    }

    //開閉処理
    if (Math.ceil(moreContent.height()) + 'px' == contentCurrentHeight) {
      contentAutoHeight = moreContent.css('height', 'auto').height();
      moreContent.css('height', contentCurrentHeight)
      $(this).text($(this).data('more-toggle-closed'));
      $(this).addClass('is-opened');
      moreContent.animate({ height: contentAutoHeight }, speed).delay(delay).queue(function () {
        moreContent.removeClass('is-hidden').dequeue();
      })
    } else {
      $(this).text($(this).data('more-toggle'));
      $(this).removeClass('is-opened')
      moreContent.addClass('is-hidden')
      moreContent.animate({ height: contentCurrentHeight }, speed)
    }
  })
})

// ====================
// もっと見る（普通）
// ====================
$(function () {
  var moreBtn = $('.js-more-btn');

  $(moreBtn).click(function () {
    var moreContent = $(this).closest('.js-more-toggle').children('.js-more-content');

    if (moreContent.hasClass('is-hidden')) {
      $(this).text($(this).data('more-toggle-closed'))
      $(this).addClass('is-opened')
      moreContent.slideDown(500, function () {
        moreContent.removeClass('is-hidden');
      });
    } else {
      $(this).text($(this).data('more-toggle'))
      $(this).removeClass('is-opened')
      moreContent.slideUp(500, function () {
        moreContent.addClass('is-hidden');
      })
    }
  })
})


// ====================
// もっと見る（resize高さ判定）
// ====================
function omitText() {

  $('.js-text').removeClass('is-hidden');
  $(".js-text-target").css({
    height: "auto",
  });

  // テキストが表示制限の行数を超えたら発動
  $('.js-text').each(function () {

    var $text = $(this).find('.js-text-target');//対象のテキスト
    var $more = $(this).find('.js-text-btn');//続きを読むボタン
    var lineNum = $text.data('line-num'); //data属性に行数指定

    var textHeight = $text.height(); // 本来のテキストの高さ
    var lineHeight = parseFloat($text.css('line-height')); //cssで指定しているline-height
    var textNewHeight = lineHeight * lineNum;//指定した行数までのテキストの高さ

    // 初期状態セット
    if (textHeight > textNewHeight) {
      $(this).addClass('is-hidden');
      $text.css({
        height: textNewHeight,
      });
      $more.show();
    }
    else {
      $more.hide();
    }

    //ボタンクリックで全文表示
    $more.click(function (e) {
      var $parent = $(this).parents(".js-text");//親js-text
      var $text = $(this).parents(".js-text").find('.js-text-target');//対象のテキスト

      $(this).fadeOut(50);
      $text.css({
        height: textHeight
      });
      $parent.removeClass('is-hidden');
      return false;
    });

  });
}


// ====================
// トグル チェックボックス（ネーム入れ・カート注文用コメント・新規会員登録休診日）
//  .js-toggle-check
//  .js-toggle-check-trigger ／ js-toggle-check-trigger-reverse
//  .js-toggle-check-panel
// ====================
$(function() {
  var trigger0 = $('.js-toggle-check-trigger'),
      checked0  = $('.js-toggle-check-trigger:checked'),
      trigger1 = $('.js-toggle-check-trigger-reverse'),
      checked1  = $('.js-toggle-check-trigger-reverse:checked');

  //flag1系のパネルは初期非表示
  trigger0.parents(".js-toggle-check").find(".js-toggle-check-panel").hide();

  //トグル起動
  toggleCheck(trigger0, checked0, 0);
  toggleCheck(trigger1, checked1, 1);

});

function toggleCheck(trigger, checkpanel, flag) {
    //flag 1：チェックONで、開くトグル
    //flag 2：チェックONで、閉じるトグル

    //初期チェック済みへの挙動
    checkpanel.each(function(){
      var target = $(this).parents(".js-toggle-check").find(".js-toggle-check-panel");

      if (flag == 0) { target.show(); }
      else           { target.hide(); }
    });

    // チェックしたら発動
    trigger.change(function() {
      var target = $(this).parents(".js-toggle-check").find(".js-toggle-check-panel");

      if ($(this).prop('checked')) {
          if(flag == 0) { target.slideDown(); }
          else          { target.slideUp(); }


      } else {
          if(flag == 0) { target.slideUp(); }
          else          { target.slideDown(); }
      }

    });

}



// ====================
// モーダル
// .js-modal-open, .js-modal-close, .js-modal
// ====================
$(function () {
  var open = $('.js-modal-open'),
    close = $('.js-modal-close'),
    modal = $('.js-modal'),
    scrollPos; //openを押下時、closeを押下時どちらもscrollPosの値が必要なため、イベント発生前に記載

  open.on('click', function (e) {
    e.preventDefault();

    var target = $(this).attr('href'),
      modal = $(document.getElementById(target));

    scrollPos = $(window).scrollTop();

    modal.fadeIn(300);
    $('body').addClass('is-fixed').css({ top: -scrollPos }); //背景固定
    $('.header').css({ top: scrollPos });
    $('.modal__overlay').css({ top: scrollPos });
    $('.navigation-btn').css({ top: scrollPos });
  })

  close.on('click', function () {
    modal.fadeOut(300);

    //閉じたとき、画面の元の位置に戻る処理
    $('body').removeClass('is-fixed').css({ top: 0 });
    $('.header').css({ top: 0 })
    $('.modal__overlay').css({ top: 0 })
    $('.navigation-btn').css({ top: 0 });
    $(window).scrollTop(scrollPos);
  })
})

// ====================
// スムーズスクロール  js-scroll
// ====================

//$(window).on('load',function() {
$(function () {

  $.easing.quart = function (x, t, b, c, d) {
    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
  };

  //URLのハッシュ値を取得
  var urlHash = location.hash;
  //ハッシュ値があればページ内スクロール

  if (urlHash) {
    //スクロールを0に戻す
    $('body,html').stop().scrollTop(0);
    setTimeout(function () {
      console.log(urlHash)
      //ロード時の処理を待ち、時間差でスクロール実行
      scrollToAnker(urlHash);
    }, 100);
  }

  scroll();

});

function scroll() {
  $('.js-scroll').on("click", function () {
    var speed = 400,
      href = $(this).attr("href"),
      target = $(href == "#" || href == "" ? 'html' : href);
    scrollToAnker(target);
    return false;
  });
}

function scrollToAnker(hash) {
  var target = $(hash),
    header = $(".header").height(),
    position = target.offset().top,
    position = position < header ? position : position - header - 15; //固定ヘッダー分+α　を適宜追加する

  $('html,body').animate({ scrollTop: position }, 1200, 'quart');
}

document.addEventListener("DOMContentLoaded", function() {
  function setupPasswordToggle(className) {
    const toggles = document.querySelectorAll(className);

    toggles.forEach(toggle => {
      const targetSelector = toggle.getAttribute('data-target');
      const passwordField = document.querySelector(targetSelector);

      if (passwordField) {
        toggle.addEventListener('click', function () {
          const type = passwordField.getAttribute('type') === 'password' ? 'text' : 'password';
          passwordField.setAttribute('type', type);
          this.classList.toggle('fa-eye');
          this.classList.toggle('fa-eye-slash');
        });
      }
    });
  }

  setupPasswordToggle('.toggle-password');
  setupPasswordToggle('.toggle-password-confirm');
  setupPasswordToggle('.toggle-current-password');
});